import type { App } from "vue";

const isDebug = process.env.NODE_ENV !== 'production';

const debugFunction = (value: any) => {
  if(isDebug) {
    return value;
  }
}

export default (App: App<Element>) => {
  //@ts-expect-error as planned
  App.config.globalProperties.$debug = debugFunction;
};